import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.916 8.458A8.46 8.46 0 0 0 8.458 0a.75.75 0 0 0-.75.75v7.708c0 .414.336.75.75.75h7.708a.75.75 0 0 0 .75-.75m-1.54-.75H9.208V1.54a6.96 6.96 0 0 1 6.168 6.168M0 8.458C0 4.566 2.63 1.288 6.208.303v1.569a6.959 6.959 0 1 0 8.837 8.837h1.57A8.459 8.459 0 0 1 0 8.458",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }